import type { Query } from '../../../types/definitionsType';
import type { FacetConfig } from '../../../types/facetsTypes';
import { TEAMSCHEDULE_BASE_FACETS } from './facetDefinitions';

export const getFacetConfig = (_query: Query): Record<string, FacetConfig[]> => ({ teamSchedule: [...TEAMSCHEDULE_BASE_FACETS] });

export const getFacetSections = (facets: FacetConfig[]) => {
    if (!facets) return [];

    const sections = [
        {
            id: 'date',
            title: 'Date',
            facets: facets.filter((facet) => ['dateFacet'].includes(facet.id)),
            collapsed: false
        },
        {
            id: 'Users',
            title: 'Users',
            facets: facets.filter((facet) => [
                'users', 'teams', 'tags', 'businessRoles',
                'locations'
            ].includes(facet.id)),
            collapsed: false
        },
        {
            id: 'tasks',
            title: 'Tasks',
            facets: facets.filter((facet) => [
                'tasks', 'tasksStartFacet', 'leaveTasks'
            ].includes(facet.id)),
            collapsed: true
        },
        {
            id: 'shift',
            title: 'Shift',
            facets: facets.filter((facet) => [
                'shiftTemplates', 'shiftStartFacet', 'shiftLocations'
            ].includes(facet.id)),
            collapsed: true
        }
    ];

    return sections.filter((section) => section.facets.length > 0);
};